/**
 * BLOCK: landing slider  ==> Content
 */
registerBlockType( 'tornado/landing-slider-content', {
    title: __('landing slider content', 'tornado'),
    description: __('landing slider content', 'tornado'),
    icon: <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill="black" d="M36,13v22h8V13 M4,35h8V13H4 M14,39h20V9H14V39z"/></svg>,
    category: 'tornado',
    keywords: [ 'tornado', 'landing slider', 'content' ],
    supports: {
        align: ['full','wide']
    },
    attributes: {
       
        section_image : {
            type: 'string',
            default: 'https://via.placeholder.com/1600x500',
        },
      
    },
    //==== Editing Mode ====//
    edit: props => {
        //==== Block Data ====//
        const { attributes, setAttributes, className, isSelected } = props;
        props.setAttributes( { align: 'full' } );
        //==== Images and icons Uploader ====//
        const section_image = (openEvent) => {
            return(<img src={ attributes.section_image } alt={ attributes.section_title } onClick={ openEvent }/>)
        };
        //==== Block Structure ====//
        return (
            <Panel>               
                <PanelBody title={ __('Slide Item', 'tornado') } initialOpen={ false }>
                    <InspectorControls key="inspector">
                        <PanelBody title={ __('Block Options', 'tornado') }>
                            <MediaUpload render={({open}) => section_image(open)} value={ attributes.section_image }  onSelect={media => { setAttributes({section_image: media.url}); }} type="image" />
                        </PanelBody>
                    </InspectorControls>
                            <div className="item">
                                <div data-src={attributes.section_image} className="responsive-element hero-intro"></div>
                            </div>
                </PanelBody>
            </Panel>
        );    
    },

    //==== Puplish Mode ====//
    save: props => {
        //==== Block Data ====//
        const { attributes} = props;
        //==== Set Default Class's ====//
   
            return (
                <div className="item">
                    <div data-src={attributes.section_image} className="responsive-element hero-intro"></div>
                </div>
             );
            },
        });